import { Workshop } from "@models/workshop";
import { Campus } from "@models/campus";
import { TutorAllocation } from "@models/tutor-allocation";

export class WorkshopsStore {
  constructor(
    public workshops: Workshop[] = [],
    public activeWorkshop: Workshop = new Workshop(),
    public activeCampus: Campus = new Campus(),
  ) {}
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/workshops.ts